import { render, staticRenderFns } from "./ForgotSuccess.vue?vue&type=template&id=388dabe9&scoped=true"
import script from "./ForgotSuccess.vue?vue&type=script&lang=js"
export * from "./ForgotSuccess.vue?vue&type=script&lang=js"
import style0 from "./ForgotSuccess.vue?vue&type=style&index=0&id=388dabe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388dabe9",
  null
  
)

export default component.exports